module.exports = __webpack_public_path__ + "static/media/icon_share_twitter.d61993ca.svg";